import { deepMap } from '@podium/store';
import type { ClientAdPlacement } from '@schibsted-nmp/advertising-shared';

import { AtomChannels, AtomTopics } from './index.js';

export const $placementsMap = deepMap<Record<string, ClientAdPlacement>>(
  AtomChannels.Podlet,
  AtomTopics.PlacementsMap,
  {}
);

export function getPlacementList(): ClientAdPlacement[] {
  return Object.values($placementsMap.get()).filter(({ placementId }) =>
    Boolean(placementId)
  );
}

export function placementHasIntermingle({
  intermingle,
  placementId
}: ClientAdPlacement) {
  if (!intermingle) return false;

  const isRecircAd =
    placementId.includes('recirc') || placementId.includes('ad-stream');

  // we don't want native retail ads to show up in the intermingles
  const isNativeRetailAd =
    placementId.includes('advt_spl_middle') ||
    placementId.includes('advt_spa_middle');

  if (isRecircAd || isNativeRetailAd) return false;

  return Boolean(intermingle.list && intermingle.grid);
}
